import { AppData } from "./app-data.service";

export type URL_KEYS =
  //login and sign up
  'sendOtp' | 'verifyOtp' | 'reSendOtp' | 'signUp' | 'cartId' | 'sendFCMToken' | 'referralCode' | 'analytics' | 'updateApk' |

  //Address
  'getCurrentAddress' | 'address' | 'getAddress' | 'updateLocation' |

  //Account
  'getFoodPreferences' | 'foodPreferencesTags' | 'updateFoodTags' | 'getFavoritesFood' | 'getOrderHistoryList' |
  'getOrderDetails' | 'getOrderStatus' | 'help' | 'helpHeadingId' | 'addFavourite' | 'getSelectedFoodPreferences' |
  'rateOrder' | 'getWalletPoints' | 'getTransactionHistory' | 'logout' | 'verifyUPI' | 'withdrawMoney' |
  'getScratchInfo' | 'getEarnedScratchCards' | 'redeemScratchCard' | 'getScratchSummary' | 'exploreFirst' | 'saveContacts' |

  // get outlet
  'outletsNearMe' |
  // outletGroup

  'outletGroup' |

  // cart
  'getCart' | 'addItem' | 'updateAddonVariant' |
  'changeItemCount' | 'preOrderCheckout' | 'placeOrder' |
  'postCheckout' | 'getAllCoupon' | 'applyCoupon' | 'removeCoupon' | 'clearPlate' | 'useWallet' | 'unUseWallet' | 'noSelfPickup' | 'selfPickup' | 'orderStatus' |
  'applyPartialPay' | 'removePartialPay' | 'scheduleSlot' | 'secheduleDelivery' |

  //Home
  'allHomeFood' | 'allHomeFoodPaginate' | 'promotionRestaurants' | 'promotionDishs' | 'appStart' | 'disableRatingFromBtmBar' |

  'getMenu' | 'searchFoodItems' | 'getExpandSearchResults' |

  // Payment
  'paymentView' | 'paymentCreate' |
  'paymentSendOtp' | 'paymentVerifyOtp' | 'checkBalance' |
  'createPayment' | 'extra' | 'createCustomPayment' |

  // Delete users
  'deleteAccountOTP' | 'deleteAccount';

const UrlMapping = {
  //login and sign up
  sendOtp: { url: AppData.baseUrl + '/account/sendOtp', showMsg: false, showLoading: true },
  reSendOtp: { url: AppData.baseUrl + '/account/sendOtp', showMsg: true, showLoading: true },
  verifyOtp: { url: AppData.baseUrl + '/account/verifyOtp', showMsg: true, showLoading: true },
  signUp: { url: AppData.baseUrl + '/account/signup', showMsg: true, showLoading: true },
  cartId: { url: AppData.baseUrl + '/cart', showMsg: false, showLoading: false },
  referralCode: { url: AppData.baseUrl + '/coupon/addReferral', showMsg: false, showLoading: false },
  // Delete Account
  deleteAccountOTP: { url: AppData.baseUrl + '/account/delete-otp', showMsg: false, showLoading: false },
  deleteAccount:{url: AppData.baseUrl + '/account/set-inactive', showMsg: false, showLoading: true},

  sendFCMToken: { url: AppData.baseUrl + '/account/fcm', showMsg: false, showLoading: false },
  analytics: { url: AppData.analyticsUrl + '/event/event', showMsg: false, showLoading: false },
  updateApk: { url: AppData.baseUrl + '/app/version/info', showMsg: false },

  //Address
  address: { url: AppData.baseUrl + '/account/address', showMsg: false, showLoading: false },
  getCurrentAddress: { url: AppData.googleMapUrl + '/maps/api/geocode/json', showMsg: false, showLoading: false },
  updateLocation: { url: AppData.baseUrl + '/account/location', showMsg: false, showLoading: false },

  //Account
  getFoodPreferences: { url: AppData.baseUrl + '/food/foodPreferencesList', showMsg: false, showLoading: true },
  foodPreferencesTags: { url: AppData.baseUrl + '/food/foodPreferencesTags', showMsg: false, showLoading: true },
  updateFoodTags: { url: AppData.baseUrl + '/account/profile', showMsg: true, showLoading: true },
  getFavoritesFood: { url: AppData.baseUrl + '/account/favourites', showMsg: false, showLoading: false },
  getOrderHistoryList: { url: AppData.baseUrl + '/order/orderHistory', showMsg: false, showLoading: false },
  getOrderDetails: { url: AppData.baseUrl + '/order/orderDetails', showMsg: false, showLoading: false },
  getOrderStatus: { url: AppData.baseUrl + '/order/orderStatus', showMsg: false, showLoading: false },
  getWalletPoints: { url: AppData.baseUrl + '/account/wallet/account/wallet', showMsg: false, showLoading: false },
  getTransactionHistory: { url: AppData.baseUrl + '/account/wallet/account/ledger', showMsg: false, showLoading: false },
  logout: { url: AppData.baseUrl + '/account/logout', showMsg: false, showLoading: true },
  verifyUPI: { url: AppData.baseUrl + '/account/validate-vpa', showMsg: false, showLoading: true },
  withdrawMoney: { url: AppData.baseUrl + '/account/wallet/account/withdraw/initiate', showMsg: false, showLoading: true },
  getScratchInfo: { url: AppData.baseUrl + '/account/scratchCard/scratchInfo', showMsg: false, showLoading: true },
  getEarnedScratchCards: { url: AppData.baseUrl + '/account/scratchCard/viewCards', showMsg: false, showLoading: false },
  redeemScratchCard: { url: AppData.baseUrl + '/account/scratchCard/redeem', showMsg: false, showLoading: false },
  getScratchSummary: { url: AppData.baseUrl + '/account/scratchCard/scratchSummary', showMsg: false, showLoading: true },
  exploreFirst: { url: AppData.baseUrl + '/account/explore', showMsg: false, showLoading: true },

  outletsNearMe: { url: AppData.baseUrl + '/rest/outletsNearMe', showMsg: false, showLoading: true },
  getCart: { url: AppData.baseUrl + '/cart', showMsg: false, showLoading: true },
  addItem: { url: AppData.baseUrl + '/cart', showMsg: false, showLoading: false },
  updateAddonVariant: { url: AppData.baseUrl + '/cart/item', showMsg: false, showLoading: true },
  changeItemCount: { url: AppData.baseUrl + '/cart/item/', showMsg: false, showLoading: false },
  addFavourite: { url: AppData.baseUrl + '/account/favourites', showMsg: false, showLoading: false },
  getSelectedFoodPreferences: { url: AppData.baseUrl + '/account/likedPrefTags', showMsg: false, showLoading: true },
  rateOrder: { url: AppData.baseUrl + '/order/rateOrder', showMsg: false, showLoading: true },
  saveContacts: { url: AppData.baseUrl + '/account/contacts/save', showMsg: false, showLoading: false },

  // help
  help: { url: AppData.baseUrl + '/app/help', showMsg: false, showLoading: true },
  helpHeadingId: { url: AppData.baseUrl + '/app/help', showMsg: false, showLoading: true },

  // pre order checkout
  preOrderCheckout: { url: AppData.baseUrl + '/order/preCheckout', showMsg: false, showLoading: false },
  placeOrder: { url: AppData.baseUrl + '/order/newOrder', showMsg: false, showLoading: false },
  postCheckout: { url: AppData.baseUrl + '/order/postCheckout', showMsg: false, showLoading: false },
  getAllCoupon: { url: AppData.baseUrl + '/coupon/couponList', showMsg: false, showLoading: true },
  applyCoupon: { url: AppData.baseUrl + '/cart/coupon', showMsg: false, showLoading: true },
  removeCoupon: { url: AppData.baseUrl + '/cart/coupon', showMsg: false, showLoading: true },
  clearPlate: { url: AppData.baseUrl + '/cart/clear', showMsg: false, showLoading: true },
  useWallet: { url: AppData.baseUrl + '/cart/use-wallet', showMsg: false, showLoading: true },
  unUseWallet: { url: AppData.baseUrl + '/cart/unuse-wallet', showMsg: false, showLoading: true },
  noSelfPickup: { url: AppData.baseUrl + '/cart/noSelfPickup', showMsg: false, showLoading: true },
  selfPickup: { url: AppData.baseUrl + '/cart/selfPickup', showMsg: false, showLoading: true },
  orderStatus:{url:AppData.baseUrl + '/order/orderStatus',showMsg: false, showLoading: false},
  applyPartialPay:{url:AppData.baseUrl + '/cart/apply-partial-pay',showMsg: false, showLoading: true}, 
  removePartialPay:{url:AppData.baseUrl + '/cart/remove-partial-pay',showMsg: false, showLoading: true},
  scheduleSlot:{url:AppData.baseUrl + '/v2/native/cart/delivery-schedule',showMsg: false, showLoading: true},
  secheduleDelivery:{url:AppData.baseUrl + '/v2/native/cart/update-schedule',showMsg: false, showLoading: true},

  //Home
  allHomeFood: { url: AppData.baseUrl + '/home/landing', showMsg: false, showLoading: false },
  // allHomeFood: { url: AppData.baseUrl + '/home/food', showMsg: false, showLoading: false },
  allHomeFoodPaginate: { url: AppData.baseUrl + '/home/landing', showMsg: false, showLoading: false },
  promotionRestaurants: { url: AppData.baseUrl + '/promotion/restaurants', showMsg: false, showLoading: false },
  promotionDishs: { url: AppData.baseUrl + '/promotion/dishes', showMsg: false, showLoading: false },
  appStart: { url: AppData.baseUrl + '/app/appStart', showMsg: false, showLoading: false },
  disableRatingFromBtmBar: { url: AppData.baseUrl + '/order/rateOrder', showMsg: false, showLoading: false },

  //Menu
  getMenu: { url: AppData.baseUrl + '/food/g-menu', showMsg: false, showLoading: false },
  searchFoodItems: { url: AppData.baseUrl + '/food/search', showMsg: false, showLoading: true },
  getExpandSearchResults: { url: AppData.baseUrl + '/food/expandSearch', showMsg: false, showLoading: true },

  // outletGroup
  outletGroup: { url: AppData.baseUrl + '/food/outletGroup', showMsg: false, showLoading: false },

  // Payment
  paymentView: { url: AppData.paymentBaseUrl + '/listAllPayments', showMsg: false, showLoading: false },
  paymentCreate: { url: AppData.paymentBaseUrl + 'paymentco/createPayment', showMsg: false, showLoading: true },
  checkBalance: { url: AppData.paymentBaseUrl + 'payment/paytm/checkBalance', showMsg: false, showLoading: true },
  extra: { url: AppData.paymentBaseUrl + '/extras', showMsg: false, showLoading: false },
  createPayment: { url: AppData.paymentBaseUrl + '/createPayment', showMsg: false, showLoading: true },
  createCustomPayment: { url: AppData.paymentBaseUrl + '/createCustomPayment', showMsg: false, showLoading: true },
  paymentSendOtp: { url: AppData.paymentBaseUrl + '/sendOtp', showMsg: false, showLoading: true },
  paymentVerifyOtp: { url: AppData.paymentBaseUrl + '/verifyOtp', showMsg: false, showLoading: true },

};

export class RequestUrl {
  static get(key: URL_KEYS): any {
    return UrlMapping[key];
  }
}
